import {
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    SelectChangeEvent,
    FormHelperText,
    SxProps,
    Theme,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import ClassifierModel from "../../core/api/ClassifierModel";

interface Props {
    value?: string;
    onChange?: (event: SelectChangeEvent<string>) => void;
    onBlur?: (event: React.FocusEvent<any>) => void;
    label?: string;
    className?: string;
    variant?: 'standard' | 'outlined' | 'filled';
    size?: 'small' | 'medium';
    name?: string;
    id?: string;
    fullWidth?: boolean;
    labelId?: string;
    error?: boolean;
    helperText?: string;
    disabled?: boolean;
    sx?: SxProps<Theme>;
}

function UserSelectInput({
    value,
    onChange,
    onBlur,
    label = 'Atsakingas asmuo',
    className,
    variant = 'outlined',
    size,
    name,
    id,
    fullWidth = true,
    labelId = 'user-select-label',
    error,
    helperText,
    disabled,
    sx
}: Props): React.ReactElement {
    const [users, setUsers] = useState<ClassifierModel[]>([]);

    useEffect(() => {
        ClassifierModel.usersClassifier().then((s) => {
            setUsers(s);
        });
    }, []);

    return (
        <FormControl fullWidth={fullWidth} error={error} size={size} variant={variant} sx={sx}>
            <InputLabel id={labelId}>{label}</InputLabel>
            <Select
                labelId={labelId}
                value={value || ''}
                onChange={onChange}
                onBlur={onBlur}
                label={label}
                variant={variant}
                size={size}
                className={className}
                name={name}
                id={id}
                error={error}
                disabled={disabled}
            >
                <MenuItem value="">Nepasirinktas</MenuItem>
                {users.map((user) => (
                    <MenuItem key={user.id} value={user.id}>
                        {user.name}
                    </MenuItem>
                ))}
                <MenuItem value="unassigned">Nepriskirtas</MenuItem>
            </Select>
            {helperText && <FormHelperText error>{helperText}</FormHelperText>}
        </FormControl>
    );
}

export default UserSelectInput; 